"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductAvailabilityForAllStores = exports.getProductAvailabilityForCurrentStore = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    availabilityForCurrentStore: {
        client: 'api/aem/stock/public/store/product/{market}',
        // server: '/public/stock/store/product/{ds}',
    },
    availabilityForAllStores: {
        client: 'api/aem/stock/public/store/sku/{market}',
        // server: '/public/stock/store/sku/{ds}',
    },
};
const getProductAvailabilityForCurrentStore = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, defaultRequestParams, isServer }, { storeNumber, storeId, productId }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.availabilityForCurrentStore, isServer, {
        market: defaultRequestParams.market,
    });
    const axiosConfig = {
        url: url,
        method: 'GET',
        params: Object.assign(Object.assign(Object.assign(Object.assign({}, defaultRequestParams), { productId }), (storeNumber && { storeNumber })), (storeId && { storeId })),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getProductAvailabilityForCurrentStore = getProductAvailabilityForCurrentStore;
const getProductAvailabilityForAllStores = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, defaultRequestParams, isServer }, { skuId }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.availabilityForAllStores, isServer, {
        market: defaultRequestParams.market,
    });
    const axiosConfig = {
        url: url,
        method: 'GET',
        params: Object.assign(Object.assign({}, defaultRequestParams), { skuId }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getProductAvailabilityForAllStores = getProductAvailabilityForAllStores;
//# sourceMappingURL=store-erp.api.js.map